import { ServiceConfigProviderSetup } from '@volkswagen-onehub/service-config-provider';
import { FetchServiceOptions } from '../types/service-configs';

function createFetchUrl(serviceURl: string | undefined, endpoint): string {
  serviceURl = !serviceURl?.endsWith('/')
    ? serviceURl?.concat('/')
    : serviceURl;

  return `${serviceURl || ''}${endpoint}`;
}

export async function fetchServiceConfigs({
  serviceURl,
  endpoint,
}: FetchServiceOptions): Promise<ServiceConfigProviderSetup> {
  const url = createFetchUrl(serviceURl, endpoint);
  const response = await fetch(url);
  const configs = await response.json();

  if (response.status >= 500) {
    return { configs: {} };
  }
  return configs;
}
